import { AxiosResponse } from "axios";
import {
	redirectToUnauthenticatedUrl,
	UNAUTHENTICATED_STATUS_CODE,
} from "src/api/utils/unauthenticatedResponse.ts";

export const onUnauthenticatedUser = (response: AxiosResponse): AxiosResponse | Promise<AxiosResponse> => {
	if (response.status === UNAUTHENTICATED_STATUS_CODE) {
		redirectToUnauthenticatedUrl(response.data.url);
		// window.location.replace is not immediate, so the caller will get broken result if we do nothing here.
		// If we throw error, the user will see error message for a short while.
		// We deal with this by returning never-resolving promise, so that time between location change
		// is used somehow.
		// See https://github.com/axios/axios/issues/715#issuecomment-290993181
		return new Promise(() => {});
	}
	return response;
};
